const vaBreakpointSymbol = Symbol("vaBreakpoint");
const defaultThresholds = {
  xs: 0,
  sm: 640,
  md: 1024,
  lg: 1440,
  xl: 1920
};
const getBreakpointDefaultConfig = () => ({
  enabled: true,
  bodyClass: true,
  thresholds: defaultThresholds
});
export { getBreakpointDefaultConfig as g, vaBreakpointSymbol as v };
//# sourceMappingURL=index.js.map
